<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <div>
      <LoaderTuin :is-loading="loader" />
    </div>
    <ToastAlert
      :is-active="toastAlert"
      :type="typeMsg"
      :message="msg"
      @close="closeToast"
    />

    <div class="p-0">
      <!-- Contenedor flexible para disposición tipo chips/tags -->
      <div class="flex flex-wrap gap-3">
        <!-- Iterar sobre los registros -->
        <div
          v-for="(item, index) in list"
          :key="item.id"
          class="flex items-center space-x-2"
        >
          <!-- Checkbox -->
          <input 
            :id="`characteristic-${item.id}-checkbox`"
            v-model="item.is_active"
            type="checkbox" 
            class="w-4 h-4 text-tuin_base-0 bg-gray-100 border-gray-300 rounded focus:ring-transparent cursor-pointer"
            @change="changeStatusOption(index)"
          >
          
          <!-- Label con nombre -->
          <label 
            :for="`characteristic-${item.id}-checkbox`" 
            class="text-sm font-medium text-custom_gray cursor-pointer whitespace-nowrap select-none"
          >
            {{ item.name }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
  import { ref, onMounted, computed, defineProps } from "vue";
  import axios from "axios";
  import LoaderTuin  from "@/commond/LoaderTuin.vue";
  import ToastAlert from "@/commond/ToastAlert.vue";


  import { useStore } from "vuex";
  const store = useStore();
  let session = computed(() => store.getters.getUserSession);

  const props = defineProps({
    resp: {
      type: Object,
      required: true,
      default: () => ({ property_name: "" }),
    },
    propertyId: {
      type: Number,
      required: true,
      default: 0,
    },
    section: {
      type: String,
      required: true,
      default: '',
    }
  });

  let toastAlert = ref(false);
  let typeMsg = ref("");
  let msg = ref("");
  let loader = ref(false);
  let list = ref([]);

  async function getCatalog() {
    let url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${props.propertyId}/${props.section}`;

    let options = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    try {
      const response = await axios.get(url, options);

      if (response.status == 401) {
        console.log("Hay que sacarlo de la sesion ");
      }

      if (response.status == 200) {
        list.value = response.data.resp;        
      }
      loader.value = false;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  onMounted(async () => {
    loader.value = true;
    await getCatalog();
  });

  function closeToast() {
    toastAlert.value = false;
  }

  async function changeStatusOption(pos){
    
    let url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${props.propertyId}/update_option`;

    let options = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    let param_post = {
      "section": props.section,
      "property_id": props.propertyId,
      "id": list.value[pos].id,
      "is_active": list.value[pos].is_active
    }
    
    try {
      const response = await axios.put(url, param_post , options);

      if (response.status == 401) {
        console.log("Hay que sacarlo de la sesion ");
      }

      if (response.status == 200) {
        console.log('[RESPUESTA]', response.data.message )
      }
      loader.value = false;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
</script>
<style>
.inline-list {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;
}
.icon-svg{
    color: #fff !important;
}
</style>